import React, { useMemo } from 'react';
import { CategoriesData, CompetitorsResults, SectionData } from './types';
import ReportCategory from './ReportCategory';
import { filterObjectByKeys } from './utils';

type Props = {
    url: string;
    categories: CategoriesData;
    sections: Record<string, SectionData>;
    competitorsSections?: Record<string, CompetitorsResults>;
};

export default function ReportCategories({ url, categories, sections, competitorsSections }: Props) {
    const categoryEntries = useMemo(() => Object.entries(categories), [categories]);

    return (
        <>
            {categoryEntries.map(([categoryName, categorySections]) => {
                const sectionsInCategory = filterObjectByKeys(sections, categorySections);
                const competitorSectionsInCategory = competitorsSections ? filterObjectByKeys(competitorsSections, categorySections) : undefined;

                return (
                    <div
                        data-cy={categoryName}
                        key={categoryName}
                    >
                        <ReportCategory
                            url={url}
                            categoryName={categoryName}
                            sections={sectionsInCategory}
                            competitorsSections={competitorSectionsInCategory}
                        />
                    </div>
                );
            })}
        </>
    );
}
